import { ActionFetch } from '@/store/actionTypes'
import { API } from '@/store/apiPath'
import { AxiosRequest } from '@/store/axiosHelper'
import { MutationStore, MutationView } from '@/store/mutationTypes'

const request = {
  actions: {
    [ActionFetch.GUFAMILY.PRIVILEGE.LIST]: ({ commit }, $params = {}) => {
      commit(MutationView.SET_LOADING_SCREEN, true)

      return AxiosRequest(API.gufamily.privilege.list($params))
        .then(($res) => {
          const data = $res.data
          if (data.success && data.data) {
            commit(MutationStore.GUFAMILY.PRIVILEGE.LIST, data.data)
          }
          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.GUFAMILY.PRIVILEGE.DETAIL]: ({ commit }, $params = {}) => {
      commit(MutationView.SET_LOADING_SCREEN, true)

      return AxiosRequest(API.gufamily.privilege.getInfo($params.id))
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.GUFAMILY.PRIVILEGE.DETAIL, data.data)
          }
          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.GUFAMILY.PRIVILEGE.CREATE]: (
      { commit, rootState },
      $params = {},
    ) => {
      commit(MutationView.SET_LOADING_SCREEN, true)
      let user = rootState.cmsUser

      if (!user) {
        user = JSON.parse(localStorage.getItem('cmsUser'))
      }

      $params.createdBy = user.id
      $params.updatedBy = user.id

      return AxiosRequest(API.gufamily.privilege.create(), $params, user.token)
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.GUFAMILY.PRIVILEGE.CREATE, data.data)
          }
          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.GUFAMILY.PRIVILEGE.UPDATE]: (
      { commit, rootState },
      $params = {},
    ) => {
      commit(MutationView.SET_LOADING_SCREEN, true)
      let user = rootState.cmsUser

      if (!user) {
        user = JSON.parse(localStorage.getItem('cmsUser'))
      }

      $params.updatedBy = user.id

      return AxiosRequest(
        API.gufamily.privilege.update($params.id),
        $params,
        user.token,
      )
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.GUFAMILY.PRIVILEGE.UPDATE, data.data)
          }
          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.GUFAMILY.PRIVILEGE.UPDATESORT]: (
      { commit, rootState },
      $params,
    ) => {
      commit(MutationView.SET_LOADING_SCREEN, true)

      let user = rootState.cmsUser

      if (!user) {
        user = JSON.parse(localStorage.getItem('cmsUser'))
      }

      $params.updatedBy = user.id

      return AxiosRequest(
        API.gufamily.privilege.updateSort(),
        $params,
        user.token,
      )
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.GUFAMILY.PRIVILEGE.UPDATESORT, data.data)
          }

          commit(MutationView.SET_LOADING_SCREEN, false)

          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.GUFAMILY.PRIVILEGE.DELETE]: ({ commit, rootState }, $id) => {
      commit(MutationView.SET_LOADING_SCREEN, true)

      const user =
        rootState.cmsUser || JSON.parse(localStorage.getItem('cmsUser'))

      return AxiosRequest(API.gufamily.privilege.delete($id), {}, user.token)
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.GUFAMILY.PRIVILEGE.DELETE, data.data)
          }
          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },
  },
}

export default request
